/** Default text size (preview-px) for the pre-publish flow (reel + post) when the
 *  user hasn't picked a per-account size yet. The person then adjusts via the
 *  size control. Template.fontSize is NOT used here — the pre-publish preview is
 *  its own source of truth and must equal the published output. */
export const DEFAULT_PREVIEW_FONT_SIZE = 24;

/**
 * Effective font size for the pre-publish preview AND every publish path, so they
 * always agree (preview == publish). Source of truth = the per-account size the
 * user picked; absent that, a fixed default (24px). Template.fontSize is
 * intentionally ignored here (it belongs to the template editor, not publish).
 * A non-positive override (0/null/undefined) is treated as "no override".
 */
export function resolveEffectiveFontSize(override: number | null | undefined): number {
  if (typeof override === 'number' && override > 0) return override;
  return DEFAULT_PREVIEW_FONT_SIZE;
}
